import cn from 'classnames';
import styles from './dropdown.module.scss';
import { ReactComponent as Arrow } from '@assets/svg/front-arrow.svg';
import { useCallback, useState } from 'react';
import { animated, useTransition } from 'react-spring';

export default function Dropdown<T>({
    value,
    onChange,
    options,
    className = '',
}: {
    value: T;
    // eslint-disable-next-line no-unused-vars
    onChange: (value: T) => void;
    options: { name: string; value: T }[];
    className?: string;
}): JSX.Element {
    const [open, setOpen] = useState<boolean>(false);
    const dropTransition = useTransition(open, {
        from: {
            maxHeight: '0px',
            padding: 0,
        },
        enter: {
            maxHeight: '700px',
            padding: '10px 0px 0px 0px',
        },
        leave: {
            maxHeight: '0px',
            padding: 0,
        },
    });

    const toggleDropdown = useCallback(
        (state: boolean) => {
            setOpen(state);
        },
        [options],
    );

    return (
        <div
            className={cn(styles.dropdown, className)}
            onMouseEnter={() => toggleDropdown(true)}
            onMouseLeave={() => toggleDropdown(false)}
        >
            <span>{value}</span>
            <Arrow />
            {dropTransition(
                (style, item) =>
                    item && (
                        <animated.div style={style} className={styles.list}>
                            {options.map((option) => (
                                <p
                                    key={option.name}
                                    onClick={() => {
                                        onChange(option.value);
                                        toggleDropdown(false);
                                    }}
                                >
                                    {option.name}
                                </p>
                            ))}
                        </animated.div>
                    ),
            )}
        </div>
    );
}
